import { Tab, Tabs } from '@blueprintjs/core'
import { Card } from './card'
import { snakeCase } from 'change-case'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { CardHeader } from './CardHeader'
import { isNavV2Enabled } from '../../util/nav-version'

export const TabbedCards = ({ tabs, children, onChange = undefined }) => {
    const { search } = useLocation()
    const useNavV2 = isNavV2Enabled(search)
    const ids = tabs.map((tab) => tab?.id || snakeCase(tab))
    const [selected, setSelected] = useState(ids[0])
    const index = ids.indexOf(selected)
    if (!Array.isArray(children)) {
        children = [children]
    }

    useEffect(() => {
        if (onChange) {
            onChange(ids[0])
        }
    }, [])

    const handleTabChange = (tabId) => {
        setSelected(tabId)

        if (onChange) {
            onChange(tabId)
        }
    }

    return (
        <Card
            className={classNames(
                'flex flex-col p-0',
                useNavV2 ? '!rounded-none !shadow-none mt-0' : 'bp4-card-rounded mt-4',
            )}
        >
            <CardHeader
                className="mt-3 py-0 flex items-end text-lg border-b"
                title={
                    <Tabs id="TabsExample" onChange={handleTabChange}>
                        {tabs.map((tab, i) => {
                            const id = tab?.id || snakeCase(tab)
                            return (
                                <Tab
                                    key={id}
                                    id={id}
                                    className="mr-4"
                                    title={<span className="text-lg">{tab}</span>}
                                />
                            )
                        })}
                    </Tabs>
                }
            />
            {children[index]}
        </Card>
    )
}
